import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { Observable } from 'rxjs';
import { map, take, tap } from 'rxjs/operators';

import { NotificationService } from '../services/notification.service';
import { MESSAGES, ROUTES } from '@utils/constants';
import { UserStateService } from '../services/state/user-state.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(
    private notificationService: NotificationService,
    private router: Router,
    private userStateService: UserStateService,
  ) {}

  public canActivate(): Observable<boolean> {
    return this.userStateService.checkUserPermissions().pipe(
      take(1),
      map((checkPermission) => checkPermission.isValid),
      tap((isLoggedInUser) => {
        if (!isLoggedInUser) {
          const message = MESSAGES.guard.notAuthenticated;
          this.notificationService.showError([message]);
          this.router.navigateByUrl(`/${ROUTES.auth.root}`);
        }
      }),
    );
  }

  public canActivateChild(): Observable<boolean> {
    return this.canActivate();
  }
}
